"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CancelReasonsUtils = void 0;
var _lodash = require("lodash");
var getCancelReasonFullText = function getCancelReasonFullText(_ref, reasons) {
  var cancelReasonId = _ref.cancelReasonId,
    _ref$cancelReasonMess = _ref.cancelReasonMessage,
    cancelReasonMessage = _ref$cancelReasonMess === void 0 ? '' : _ref$cancelReasonMess;
  var reason = (0, _lodash.find)(reasons, function (_ref2) {
    var id = _ref2.id;
    return id === cancelReasonId;
  });
  var cancelReasonText = reason === null || reason === void 0 ? void 0 : reason.reasonText;
  return cancelReasonText ? cancelReasonMessage ? "".concat(cancelReasonText, ": ").concat(cancelReasonMessage) : cancelReasonText : cancelReasonMessage;
};

// Determining which reasons cause which deflections. Usage:
// if (cancelReasonIs.therapy(reason)) {
//   // execute therapy deflection
// }
var testReason = function testReason(checkFunction) {
  return function (reason) {
    return checkFunction(reason.toLowerCase());
  };
};
var cancelReasonIs = {
  medication: testReason(function (str) {
    return str.includes('medication');
  }),
  // Catches therapy related reasons, excluding "I found a local physician or therapist"
  therapy: testReason(function (str) {
    return str.includes('therapy') || str.includes('my therapist');
  }),
  financial: testReason(function (str) {
    return str.includes('too expensive') || str.includes('budget');
  }),
  takeBreak: testReason(function (str) {
    return str.includes('i want to take a break');
  }),
  physician: testReason(function (str) {
    return str.includes('like my physician');
  })
};
var CancelReasonsUtils = {
  getCancelReasonFullText: getCancelReasonFullText,
  cancelReasonIs: cancelReasonIs
};
exports.CancelReasonsUtils = CancelReasonsUtils;